import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	Container,
	Card,
	CardBody,
	Label,
	Button,
	Col, Modal, ModalBody, ModalHeader, ModalFooter
} from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvFeedback, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import { updateUser, changePassword, dispatchErrorMessage, deleteUserProfile } from '../../actions/index';
import { localizeCountryNames } from '../../utils/CommonUtils';
import { countryList } from '../../utils/Constants';

class ProfileScreen extends Component {

	constructor(props) {
		super(props);
		this.state = {
			id: -1,
			name: '',
			phone: '',
			email: '',
			language: 'en',
			countryCode: '',
			currentPassword: '',
			newPassword: '',
			repeatNewPassword: '',
			stateAlreadyCopiedFromProps: false,
			isConfirmationScreenOpen: false
		}

		this.changeState = this.changeState.bind(this);
		this.toggleConfirmationScreen = this.toggleConfirmationScreen.bind(this);
	}

	copyStateFromProps() {
		if (!this.state.stateAlreadyCopiedFromProps) {
			this.setState({
				id: Number(this.props.user.id),
				name: this.props.user.name,
				phone: this.props.user.phone,
				email: this.props.user.email,
				language: this.props.user.language,
				countryCode: this.props.user.countryCode,
				stateAlreadyCopiedFromProps: true
			});
		}
	}

	toggleConfirmationScreen() {
		this.setState({
			...this.state,
			isConfirmationScreenOpen: !this.state.isConfirmationScreenOpen
		});
	}

	changeState({ target }) {
		this.setState({ ...this.state.user, [target.name]: target.value });
	}

	updateUser() {
		const regex = /[A-Za-z]/g;
		const isValidPhoneNumber = this.state.phone.match(regex);
		const regexNumbers = /[0-9]/g;
		let newPhone = [];
		this.state.phone.match(regexNumbers).map(singleNumber => {
			newPhone.push(singleNumber);
		});

		if (newPhone > 17) {
			return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneTooLong'));
		}

		if (isValidPhoneNumber !== null) {
			return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.invalidPhone'));
		}
		const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

		// Parse number with country code and keep raw input.
		const number = phoneUtil.parseAndKeepRawInput(this.state.phone, this.state.countryCode);
		let validNumber = phoneUtil.isValidNumberForRegion(number, String(this.state.countryCode));

		if (!validNumber) {
			return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneMatchFailure'));
		}
		this.props.updateUser(this.state);
	}

	changePassword() {
		const { currentPassword, newPassword } = this.state;
		this.props.changePassword(currentPassword, newPassword);
		this.form && this.form.reset();
	}

	deleteAccount() {
		const userId = this.state.id;
		this.props.deleteUserProfile(userId, () => {
			this.toggleConfirmationScreen();
		});
	}

	renderProfileContainer() {
		const { profileContainer, buttonFloatRight, spaceBetween } = styles;

		return (
			<div style={profileContainer}>
				<Card>
					<CardBody>
						<AvForm onValidSubmit={this.updateUser.bind(this)} >
							<AvGroup>
								<Label for="userName">{i18n.t('common:form.name')}</Label>
								<AvInput type="text" name="name" id="userName" placeholder={i18n.t('common:form.name')}
									value={this.state.name} onChange={this.changeState}
									required />
								<AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
							</AvGroup>
							<AvGroup>
								<Label for="phone">{i18n.t('common:form.phone')}</Label>
								<AvInput type="phone" name="phone" id="phone" placeholder={i18n.t('common:form.phone')}
									value={this.state.phone} onChange={this.changeState}
									required />
								<AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
							</AvGroup>
							<AvGroup>
								<AvField type="email" name="email" id="email" placeholder={i18n.t('common:form.email')} label={i18n.t('common:form.email')}
									value={this.state.email} onChange={this.changeState}
									required
									errorMessage={i18n.t('common:validations.errorMsg')}
								// validate={{
								// 	pattern: {
								// 		value: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$',
								// 		errorMessage: i18n.t('common:validations.errorMsgEmail')
								// 	}
								// }}
								/>
								<AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
							</AvGroup>
							<AvGroup>
								<AvField type="select" name="countryCode" id="country" placeholder={i18n.t('screens:restaurantsScreen.country')} label={i18n.t('screens:restaurantsScreen.country')}
									value={this.state.countryCode}
									errorMessage={i18n.t('common:validations.chooseCountry')}
									required
									onChange={this.changeState}
								>
									<option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
									{this.renderCountryOptions()}
								</AvField>
							</AvGroup>
							<AvGroup>
								{/* TODO this should be taken from an API service */}
								<AvField type="select" name="language" id="language" placeholder={i18n.t('common:form.lang')} label={i18n.t('common:form.lang')}
									value={this.state.language}
									errorMessage={i18n.t('common:validations.chooseLanguage')}
									required
								>
									<option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
									<option value="en">{i18n.t('common:languages.english')}</option>
								</AvField>
							</AvGroup>
							<Button style={buttonFloatRight} color="primary">
								<MaterialIcon icon="save" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span></Button>
						</AvForm>
					</CardBody>
				</Card>
			</div>
		);
	}

	renderCountryOptions() {
		return countryList.map((country, i) => {
			return <option key={i} value={country}>{localizeCountryNames(country)}</option>
		});
	}

	renderPasswordContainer() {
		const { passwordContainer, buttonFloatRight, spaceBetween } = styles;

		return (
			<div style={passwordContainer}>
				<Card>
					<CardBody>
						{/* Тhis Form is created with AvField element because we need more then one validation. This field support this. */}
						<AvForm onValidSubmit={this.changePassword.bind(this)} ref={c => (this.form = c)} >
							<AvGroup>
								<AvField name="currentPassword" label={i18n.t('screens:profileScreen.currentPass')} type="password" minLength={6}
									value={this.state.currentPassword}
									onChange={this.changeState}
									required
									errorMessage={i18n.t('common:validations.errorMsg')}
									validate={{
										minLength: {
											value: 6,
											errorMessage: i18n.t('common:validations.passLength')
										}
									}}
								/>
							</AvGroup>
							<AvGroup>
								<AvField name="newPassword" label={i18n.t('screens:profileScreen.newPass')} type="password" minLength={6}
									value={this.state.newPassword}
									onChange={this.changeState}
									required
									errorMessage={i18n.t('common:validations.errorMsg')}
									validate={{
										minLength: {
											value: 6,
											errorMessage: i18n.t('common:validations.passLength')
										}
									}}
								/>
							</AvGroup>
							<AvGroup>
								<AvField name="repeatNewPassword" label={i18n.t('screens:profileScreen.repeatNewPass')} type="password"
									value={this.state.repeatNewPassword}
									onChange={this.changeState} required
									errorMessage={i18n.t('common:validations.errorMsg')}
									validate={{
										match: {
											value: 'newPassword',
											errorMessage: i18n.t('common:validations.matchPasswords')
										}
									}}
								/>
							</AvGroup>
							<Button style={buttonFloatRight} color="primary">
								<MaterialIcon icon="save" color="#fff" size={18} />
								<span style={spaceBetween}>{i18n.t('screens:profileScreen.changePassBtn')}</span>
							</Button>
						</AvForm>
					</CardBody>
				</Card>
			</div>
		);
	}

	renderDeactivateProfileContainer() {
		const { deleteAccountContainer, buttonFloatRight, spaceBetween } = styles;

		return (
			<div style={deleteAccountContainer}>
				<Card>
					<CardBody style={{ marginBottom: -6 }} >
						<AvForm onValidSubmit={() => this.toggleConfirmationScreen()} ref={c => (this.form = c)} >
							<AvGroup style={{ float: 'left', marginTop: 12, marginBottom: 7 }} >
								<Label for="active">{i18n.t('screens:profileScreen.deleteAccount')}</Label>
							</AvGroup>
							<Button style={buttonFloatRight} color="primary">
								<span className="deleteIcon"><MaterialIcon icon="delete" color="#fff" size={18} /></span>
								<span style={spaceBetween}>{i18n.t('common:buttons.delete')}</span>
							</Button>
						</AvForm>
					</CardBody>
				</Card>
			</div>
		);
	}

	render() {
		const { screenTitleContainer } = styles;

		this.copyStateFromProps();

		return (
			<Container className="container h-100">
				<Col xs="2" style={screenTitleContainer}>
					<div><MaterialIcon icon="person" color="#0288d1" /> &nbsp;{i18n.t('screens:profileScreen.heading')}</div>
				</Col>
				<div className="row h-100 justify-content-center align-items-start">
					<Col md={12}>
						<Col md={6} style={{ float: 'left' }}>
							{this.renderProfileContainer()}
						</Col>
						<Col md={6} style={{ float: 'right' }}>
							{this.renderPasswordContainer()}
							{this.renderDeactivateProfileContainer()}
						</Col>
					</Col>
				</div>
				<Modal isOpen={this.state.isConfirmationScreenOpen} toggle={this.toggleConfirmationScreen}>
					<ModalHeader className="modalHeader" toggle={this.toggleConfirmationScreen}>
						Confirmation
					</ModalHeader>
					<ModalBody>
						<p>{i18n.t('screens:profileScreen.deleteAccountMsg')}</p>
						<p>{i18n.t('screens:profileScreen.deleteAccountMsgConfirmation')}</p>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" sm={12} style={{ float: 'right' }} onClick={() => this.deleteAccount()}>
							<span className="deleteIcon"><MaterialIcon icon="delete" color="#fff" size={18} /></span>
							<span style={{ paddingLeft: 4 }}>{i18n.t('common:buttons.delete')}</span>
						</Button>
						<Button outline color="primary" onClick={this.toggleConfirmationScreen}>{i18n.t('common:buttons.cancel')}</Button>
					</ModalFooter>
				</Modal>
			</Container>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user
	};
};

export default connect(mapStateToProps, { updateUser, changePassword, dispatchErrorMessage, deleteUserProfile })(ProfileScreen);

let styles = {
	profileContainer: {
		width: 500
	},
	passwordContainer: {
		paddingLeft: 50,
		width: 500
	},
	deleteAccountContainer: {
		paddingLeft: 50,
		paddingTop: 16,
		width: 500
	},
	screenTitleContainer: {
		borderBottom: 1,
		borderBottomStyle: 'solid',
		borderBottomColor: 'blue',
		alignSelf: 'flex-end',
		borderColor: 'rgb(222, 226, 230)',
		paddingLeft: 0,
		marginTop: 30,
		marginBottom: 30,
		color: '#0288d1'
	},
	buttonFloatRight: {
		float: 'right'
	},
	spaceBetween: {
		paddingLeft: 4
	}
}


// WEBPACK FOOTER //
// ./src/components/users/ProfileScreen.js